import RetailerSelection from "./RetailerSelection";
export default RetailerSelection;